import {SpaceTr, SpaceTrSpace, Tr, TrSpace} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {BonusStatus, PurchaseInfo} from "@/store/shop/types";
import {Link} from "@/scenes.ui/link";
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import BonusPointUtils from "@/utils/bonus-point-utils";
import CU from "@/utils/c-u";

export class BonusPointsPanel extends VerticalLongPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, pi: PurchaseInfo, showManual: () => unknown) {
        super(scene, canvas, Tr('success.purch'));

        let block1 = TextUtils.addTextAdvanced(scene, TrSpace('pnts.got') + pi.pointsToTake + SpaceTr('pnts') + '!', 0, -200,
            '#20ffe5', 16, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        let block2 = TextUtils.addTextAdvanced(scene, Tr('mk.purch.dr.week'), 0, block1.y / CU.S + 80,
            '#f3f3f3', 13, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        let block3 = TextUtils.addTextAdvanced(scene, Tr('bn.lim'), 0, block2.y / CU.S + 55,
            '#929292', 12, 'normal', 450, 'center', 2, Fonts.ARIAL_MT);

        let block4 = TextUtils.addTextByFamily(scene,
            TrSpace('u.hv') + BonusPointUtils.getStatusNominative(pi.statusAfterPurchase) + SpaceTr('stts'),
            0, block3.y / CU.S + 45, '#ffd12b', 11, 'bold', 400, Fonts.MYRIADPRO_REGULAR);

        let block5 = TextUtils.addTextByFamily(scene,
            TrSpace('st.desc.2') + BonusPointUtils.getStatusPercent(pi.statusAfterPurchase) + Tr('pct.gms') + ')',
            0, block4.y / CU.S + 30, '#dcdcdc', 11, 'bold', 400, Fonts.MYRIADPRO_REGULAR);

        let block6 = TextUtils.addTextByFamily(scene, BonusPointsPanel.getAimText(pi),
            0, block5.y / CU.S + 60, '#a5a5a5', 11, 'bold', 400, Fonts.MYRIADPRO_REGULAR);

        let manual = new Link(scene, 0, block6.y + 30 * CU.S, Tr('det'), showManual,
            '#A5A5A5FF', 11, 0.5);

        this.add([block1, block2, block3, block4, block5, block6, manual]);

        this.addCustomButton(0, 200, Tr('prinjat'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {});
    }

    private static getAimText(pi: PurchaseInfo) {
        if (pi.statusAfterPurchase === BonusStatus.BRILLIANT) {
            return Tr('mx.st');
        }
        return TrSpace('by.mr') + String(pi.remainTillNextStatus) + SpaceTrSpace('buy.get')
            + BonusPointUtils.getStatusNominative(pi.nextTargetStatus).toLowerCase() + SpaceTr('stts').toLowerCase() + '.';
    }
}
